import styled from "styled-components";
import { BbotAlert, SettingsCard } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 15px;
`;

export const SettingHint = styled.div`
  color: var(--color-neutral__text-secondary);
  font-size: 16px;
`;

export const WarningHint = styled(SettingHint)`
  color: var(--color-error__regular);
  font-style: italic;
`;

// A label's text and its help-tooltip icon, as two flex items rather than
// inline siblings: AntD's icon baseline otherwise sits lower than the text.
export const LabelWithTooltip = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const MovedCardBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  p {
    margin: 0;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

// Mirrors editCustomerProperties.html's red/darkred styling on Super Admin Actions and Danger
// Zone - collapsed to one semantic color rather than legacy's two ad-hoc red shades.
export const DangerSettingsCard = styled(SettingsCard)`
  .ant-card-head-title {
    color: var(--color-error__regular);
  }
`;

export const DangerLabel = styled.label`
  color: var(--color-error__regular);
`;

// SettingsCard itself caps every input at max-width: 400px, via .ant-card-body > div input -
// two classes plus two elements beats a plain ".ant-input" override on specificity regardless
// of stylesheet order, so &&& (repeats this component's own class 3x) is needed to win; see
// BbotButton.js/BbotTag.js/etc. in top-component-library for the same trick against antd CSS.
export const FullWidthInputRow = styled.div`
  &&& .ant-input {
    max-width: none;
    width: 100%;
  }
`;

export const InputCheckboxSplitRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &&& .ant-input {
    max-width: none;
  }

  > :first-child {
    flex: 4;
  }

  > :last-child {
    flex: 1;
    white-space: nowrap;
  }
`;
